import Help from "../components/Help";
import PageHeader from "../components/PageHeader";
import { helpPagesData } from "../utils/helper";

export default function Drafts() {
  return (
    <>
      <PageHeader pageTitle="Drafts">
   
        <Help
            title={helpPagesData.pages.title}
            message={helpPagesData.pages.message}
            items={helpPagesData.pages.items}
          />
          <button className="btn-black">Create New</button>
    
      </PageHeader>
      <div className="page-container">
        <p>Drafts</p>
      </div>
    </>
  );
}
